<template>
    <div>
        <!--<nav-back :dataTit="'拍照'"></nav-back>-->
        <!--<def-hn></def-hn>-->
        <div class="photo-container">
            <div class="bont">
                <img @click="goReady" class="bont-icon" src="../../assets/common/qiehuan.png"/>
                <span @click="selectFocus" class="focus-num">{{checkFocus}} x</span>
            </div>
            <div id="canvas-container">
                <img class="photo-img" id="photo-img" :src="checkImg"/>
                <video class="video-class" crossOrigin="anonymous" style="object-fit: cover;" ref="video" id="video" :width="videoWidth" :height="videoHeight" autoplay playsinline></video>
            </div>
        </div>
        <div class="photo-bonts">
            <div class="album" @click="goF">
                <img class="album-one" :src="topImg"/>
            </div>
            <div class="iconfont icon-paizhao" @click="getPhoto">
            </div>
            <div class="iconfont icon-xiangce" @click="goAlbum"></div>
        </div>
        <div class="canvas-calss" v-show="canvasShow">
            <div class="bonts">
                <div>
                    <span class="iconfont icon-fanhui1" @click="canvasShow = false"> 返回</span>
                    <span class="post-class" @click="postPhoto">保存</span>
                </div>
                <div class="save-class">长按图片下载到本地</div>
            </div>
            <img :src="imgSrc" :style="'width: ' + videoWidth + 'px;height: ' + videoHeight + 'px;z-index: 100;'"/>
            <canvas id="canvas1" :width="caWidth" :height="caHeight"></canvas>
            <div class="share-container">
                <img  src="../../assets/common/peng.png"/>
                <div @click="goyanzheng">分享至朋友圈吧~</div>
            </div>
        </div>
        <share :isShow="shareShow" :isUrl="isUrl" @showfalse="shareShow = false"></share>
    </div>
</template>

<script>
  import NavBack from "../public/navBack"
  import DefHn from "../public/defHn"
  import { Toast, Indicator } from 'mint-ui'
  let currentStream;
  import Share from "../public/share"

  export default {
    name: "photo",
    components: {NavBack, DefHn, Toast, Indicator, Share},
    data() {
      return {
        tempFilePath: '',
        canvas: '',
        context: '',
        currentStream: undefined,
        videoHeight: '',
        videoWidth: '',
        videoType: [],
        videoIndex: 0,
        videoCount: 0,
        oneShow: false,
        canvasShow: false,
        imgSrc: '',
        topImg: '',
        checkImg: '',
        checkFocus: 1,
        oldWid: '',
        oldHei: '',
        defWid: '',
        defHei: '',
        videoBase: '',
        caWidth: '',
        caHeight: '',
        shareShow: false,
        isUrl: ''
      }
    },
    mounted () {
      // WeixinJSBridge.call('showOptionMenu');
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      document.body.parentNode.style.overflow = "hidden"
      let video1 = document.getElementById('video')
      video1.style.transform = 'rotateY(180deg)'
      this.getFrames()
    },
    watch: {
      videoIndex () {
        let video1 = document.getElementById('video')
        video1.style.transform = this.videoIndex === 0 ? 'rotateY(180deg)': 'rotateY(0deg)'
      },
      canvasShow () {
        if (!this.canvasShow) {
          this.videoWidth = this.oldWid
          this.videoHeight = this.oldHei
        }
      }
    },
    methods: {
      selectFocus () {
        let video1 = document.getElementById('video')
        if (this.checkFocus === 1) {
          this.videoWidth = this.videoWidth * 1.5
          this.videoHeight = this.videoHeight * 1.5
          video1.style.margin = `0 0 0 0`
          video1.style.width = '100%'
          this.checkFocus = 2
        } else {
          this.videoWidth = this.videoWidth / 1.5
          this.videoHeight = this.videoHeight / 1.5
          video1.style.margin = `80px auto 0 auto`
          video1.style.width = '85%'
          // video1.style.margin = `${this.videoHeight / 1.5 / 2 + 'px'} 0 0 ${this.videoWidth / 1.5 / 2 + 'px'}`
          this.checkFocus = 1
        }
      },
      photoBegin () {
        let video1 = document.getElementById('video')
        // navigator.mediaDevices.enumerateDevices().then(() => {
        //   this.gotDevices
        //   this.videoHeight = document.getElementById("photo-img").offsetHeight / 1.5
        //   this.videoWidth = document.getElementById("photo-img").offsetWidth / 1.5
        //   this.defWid = document.getElementById("photo-img").offsetWidth
        //   this.defHei = document.getElementById("photo-img").offsetHeight
        //   video1.style.margin = `${this.videoHeight / 1.5 / 2 + 'px'} 0 0 ${this.videoWidth / 1.5 / 2 + 'px'}`
        //   this.goChange()
        // })
        setTimeout(() => {
          navigator.mediaDevices.enumerateDevices().then(this.gotDevices)
          this.videoHeight = document.getElementById("photo-img").offsetHeight / 1.5
          this.videoWidth = document.getElementById("photo-img").offsetWidth / 1.5
          this.defWid = document.getElementById("photo-img").offsetWidth
          this.defHei = document.getElementById("photo-img").offsetHeight
          this.caWidth = document.getElementById("photo-img").offsetWidth
          this.caHeight = document.getElementById("photo-img").offsetHeight
          video1.style.margin = `80px auto 0 auto`
          video1.style.width = '85%'
          // video1.style.margin = `${this.videoHeight / 1.5 / 2 + 'px'} 0 0 ${this.videoWidth / 1.5 / 2 + 'px'}`
          this.goChange()
        }, 500)
      },
      // 去相框列表
      goF () {
        this.$router.push('/album/frame?eid=' + this.$route.query.eid)
      },
      // 去相册
      goAlbum () {
        this.$router.push('/album/index?eid=' + this.$route.query.eid)
      },
      save () {
        let canvas1 = document.getElementById('canvas1')
        this.imgSrc = canvas1.toDataURL("image/png", 0.5)
      },
      downLoad(url){
        let oA = document.createElement("a");
        oA.download = '';// 设置下载的文件名，默认是'下载'
        oA.href = url;
        document.body.appendChild(oA);
        oA.click();
        oA.remove(); // 下载之后把创建的元素删除
      },
      getFrames () {
        let that = this
        this.$g.ajax({
          method: 'post',
          path: 'frames/getTop',
          data: {
            event_id: this.$route.query.eid
          },
          cbSuccess(data) {
            that.topImg = data.memo.src
            if (parseInt(that.$route.query.fid) === 0) {
              that.checkImg = data.memo.src
            } else {
              that.checkImg = that.$route.query.fid
            }
            that.photoBegin()
          },
          cbError(data) {
            let msg = data.msg
            Toast({
              message: msg,
              position: 'bottom',
              duration: 1000
            })
          }
        })
      },
      // 上传
      postPhoto () {
        Indicator.open({
          text: '保存中...',
          spinnerType: 'fading-circle'
        })
        let that = this
        this.$g.ajax({
          method: 'post',
          path: 'userAlbums/upload',
          data: {
            event_id: this.$route.query.eid,
            photo: this.videoBase,
            frame: this.checkImg,
            mix_pic: this.imgSrc
          },
          cbSuccess(data) {
            that.isUrl = 'photo/browse?imgurl=' + data.memo + '&eid=' + that.$route.query.eid
            Toast({
              message: '已保存至相册',
              position: 'bottom',
              duration: 1000
            })
            Indicator.close()
          },
          cbError(data) {
            let msg = data.msg
            Toast({
              message: msg,
              position: 'bottom',
              duration: 1000
            })
          }
        })
      },
      getPixelRatio (context) {
        let backingStore = context.backingStorePixelRatio ||
          context.webkitBackingStorePixelRatio ||
          context.mozBackingStorePixelRatio ||
          context.msBackingStorePixelRatio ||
          context.oBackingStorePixelRatio ||
          context.backingStorePixelRatio || 1;
        return (window.devicePixelRatio || 1) / backingStore;
      },
      getPhoto () {
        let that = this
        this.oldWid = this.videoWidth
        this.oldHei = this.videoHeight
        let vw = 0
        let vh = 0
        if (this.checkFocus === 1 && this.videoIndex !== 0) {
          vw = this.defWid / 1.65
          vh = this.defHei / 1.5 / 2.7
        } else {
          vw = this.checkFocus === 1 ? this.defWid / 1.5 / 2.3: 0
          vh = this.checkFocus === 1 ? this.defHei / 1.5 / 2.7: -this.defHei / 1.5 / 2.2
        }
        let height = this.checkFocus === 1 ? this.videoHeight + this.videoHeight * 0.4 : this.videoHeight + this.videoHeight * 0.15
        console.log(this.videoWidth, this.videoHeight)
        Indicator.open({
          text: '照片生成中...',
          spinnerType: 'fading-circle'
        })
        // document.getElementById("photo-img").setAttribute('crossOrigin', 'anonymous')
        let canvas1 = document.getElementById('canvas1')
        let context = canvas1.getContext('2d')
        let ratio = this.getPixelRatio(context)
        canvas1.width = this.caWidth * ratio
        canvas1.height = this.caHeight * ratio
        let canvasImg = document.getElementById('photo-img')
        this.videoBase = ''
        // context.drawImage(canvasImg, 0, 0, this.videoWidth, this.videoHeight)
        const posterBg = new Image()
        posterBg.crossOrigin = "anonymous"
        posterBg.src = canvasImg.src + '?t=' + new Date().valueOf()
        posterBg.onload = () => {
          if (this.videoIndex === 0) {
            context.translate(canvas1.width, 0);
            context.scale(-1, 1);
          }
          this.$nextTick(() => {
            context.drawImage(this.$refs.video, vw, vh, this.videoWidth * ratio, height * ratio)
            that.videoBase = canvas1.toDataURL("image/jpg", 1)
            if (that.videoIndex === 0) {
              context.translate(canvas1.width, 0);
              context.scale(-1, 1);
            }
            that.$nextTick(() => {
              context.drawImage(posterBg, 0, 0, that.defWid * ratio, that.defHei * ratio)
              that.imgSrc = canvas1.toDataURL("image/jpg", 1)
              Indicator.close()
              that.canvasShow = true
              that.videoWidth = document.getElementById("photo-img").offsetWidth
              that.videoHeight = document.getElementById("photo-img").offsetHeight
            })
          })
        }
      },
      goReady () {
        if (this.videoIndex === 0) {
          this.videoCount++
          if (this.videoCount >= this.videoType.length) {
            if (this.videoType.length === 1) {
              this.videoCount = 0
            } else {
              this.videoCount = 1
            }

          }
          this.videoIndex = this.videoCount
        } else {
          this.videoIndex = 0
        }

        this.goChange()
      },
      goChange () {
        if (typeof currentStream !== 'undefined') {
          this.stopMediaTracks(currentStream);
        }
        // environment
        const videoConstraints = {
          width: 1280,
          height: 720
        };
        if (this.videoIndex === 0 || this.videoType.length === 0) {
          videoConstraints.facingMode = 'user';
        } else {
          // videoConstraints.deviceId = { exact: this.videoType[this.videoIndex] };
          videoConstraints.deviceId = { exact: this.videoType[this.videoType.length - 1] };
        }
        // if (this.videoIndex === 0 || this.videoType.length === 0) {
        //   videoConstraints.facingMode = 'user';
        // } else {
        //   videoConstraints.facingMode = { exact: 'environment' };
        // }
        const constraints = {
          video: videoConstraints,
          audio: false
        };
        navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          currentStream = stream;
          this.$refs.video.srcObject = stream;
          return navigator.mediaDevices.enumerateDevices();
        })
        .then(this.gotDevices)
        .catch(error => {
          console.error(error);
        });
        Indicator.close()
      },
      stopMediaTracks(stream) {
        stream.getTracks().forEach(track => {
          track.stop();
        });
      },
      gotDevices(mediaDevices) {
        this.videoType = []
        this.test = []
        mediaDevices.forEach(mediaDevice => {
          if (mediaDevice.kind === 'videoinput') {
            this.videoType.push(mediaDevice.deviceId)
          }
        })
      },
      // 分享
      goyanzheng () {
        if (this.isUrl === '') {
          Toast({
            message: '请点击保存后分享朋友圈',
            position: 'bottom',
            duration: 1000
          })
        } else {
          this.shareShow = true
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .photo-container{
        position: relative;
        background-color: #000000;
        min-height: 1000px;
        .bont{
            position: absolute;
            top: 10px;
            right: 10px;
            color: #ffffff;
            z-index: 11;
            .bont-icon{
                width: 40px;
                height: 40px;
            }
            .focus-num{
                display: inline-block;
                width: 26px;
                height: 26px;
                border: 1px solid #fff;
                text-align: center;
                line-height: 26px;
                border-radius: 50%;
                position: relative;
                top: -16px;
                margin-left: 10px;
                font-size: 13px;
            }
        }
        .photo-img{
            position: absolute;
            top: 0;
            width: 100%;
            z-index: 10;
        }
        .video-class{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }
    .photo-bonts{
        display: flex;
        justify-content: space-around;
        background-color: #000;
        padding: 20px 0;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        height: 104px;
        z-index: 11;
        .album{
            width: 50px;
            margin-top: 10px;
            .album-one{
                width: 100%;
            }
        }
        .icon-paizhao{
            font-size: 80px;
            color: #FFFFFF;
        }
        .icon-xiangce{
            margin-top: 25px;
            font-size: 35px;
            color: #FFFFFF;
        }
    }
    .canvas-calss{
        z-index: 99;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #000000;
        padding: 20px 0 16% 0;
        .bonts{
            padding: 0 16px 10px 16px;
            display: flex;
            justify-content: space-between;
        }
        .icon-fanhui1{
            color: #ffffff;
        }
        #canvas1{
            margin-top: 100px;
        }
        .post-class{
            color: #ffffff;
            margin-left: 14px;
        }
        .save-class{
            text-align: right;
            color: #ffffff;
            font-size: 14px;
            line-height: 20px;
        }
        .share-container{
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 62px;
            background-color: #999999;
            display: flex;
            justify-content: center;
            img{
                width: 50px;
                height: 50px;
                margin-top: 4px;
            }
            div{
                color: #ffffff;
                font-size: 20px;
                margin-top: 16px;
                margin-left: 4px;
            }
        }
    }
</style>
<style>
    .mint-indicator-wrapper{
        z-index: 999;
    }
</style>


// WEBPACK FOOTER //
// src/components/photo/index.vue